// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ImageStack(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ImageStack" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.4 2.75H23V17.05H5.4V2.75ZM20.36 13.475H8.04L11.12 7.91389L13.0931 11.506L16.125 6.325L20.36 13.475Z", fill: "currentColor" }),
            React.createElement("path", { d: "M1 20.9H19.7V18.7H3.2V5.5H1V20.9Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ImageStack.js.map